module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unableToDownload":"Unable to download attachment {file}","loading":"Loading...","unableToGetEmailSignature":"There was a problem retrieving the email signature"},"es":{"unableToDownload":"No fue posible descargar el archivo adjunto {file}","loading":"Cargando...","unableToGetEmailSignature":"Hubo un problema al obtener la firma del correo"}}')
  delete Component.options._Ctor
}
